<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input lazy"
                @submit.prevent="storeGateway">
            <v-card style="position: relative;">
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Add New Gateway</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>
                <v-overlay :model-value="!formReady" contained class="align-center justify-center">
                    <v-progress-circular indeterminate color="primary"/>
                </v-overlay>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col v-if="authStore.user.type==='admin'" cols="12" sm="6">
                            <company-select v-model="formData['company_id']" :items="companies"
                                      density="compact" label="Company">
                            </company-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select v-model="formData['type']" :items="gatewayTypes" :rules="[vRules.required]"
                                      density="compact" label="Type">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['serial_number']"
                                          :rules="[vRules.required]" autofocus density="compact" label="Serial Number"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['eth_mac']"
                                          :rules="[vRules.required]" density="compact" label="ETH Mac"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['wifi_mac']"
                                          :rules="[vRules.required]" density="compact" label="Wifi Mac"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['cellular_imei']"
                                          :rules="[vRules.required]" density="compact" label="Cellular Imei"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['cellular_sim1_iccid']" density="compact"
                                          :rules="[vRules.required]" label="Cellular Sim1 Iccid"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['cellular_sim2_iccid2']" density="compact"
                                          :rules="[vRules.required]" label="Cellular Sim2 Iccid"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['ble_mac1']" :rules="[vRules.required]"
                                          density="compact" label="Ble mac1"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['ble_mac2']" :rules="[vRules.required]"
                                          density="compact" label="Ble mac2"/>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['ble_mac3']" :rules="[vRules.required]"
                                          density="compact" label="Ble mac3"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['location_label']" :rules="[vRules.required]"
                                          density="compact" label="Location label"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['address_1']" :rules="[vRules.required]"
                                          density="compact" label="Address 1"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['address_2']" :rules="[vRules.required]"
                                          density="compact" label="Address 2"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['city']" :rules="[vRules.required]"
                                          density="compact" label="City"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['state']" :rules="[vRules.required]"
                                          density="compact" label="State"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['country_code']" :rules="[vRules.required]"
                                          density="compact" label="Country Code"/>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="formData['zip_postal_code']" :rules="[vRules.required]"
                                          density="compact" label="Zip Postal Code"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" style="height: 300px">
                            <l-map ref="mapContainer"
                                   :center="[(formData.polygon_coordinates?.[0].lat??47.41322), (formData.polygon_coordinates?.[0].lng??-1.219482)]"
                                   :zoom="10" @ready="mapIsReady">
                                <l-tile-layer :url="$mapTiles.street"/>
                            </l-map>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button" @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/assets/css/leaflet.css";

import "leaflet-draw";
import L from "leaflet";
import {reactive, ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {LMap, LTileLayer} from "@vue-leaflet/vue-leaflet";
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import {mapTiles} from "@/composables/mapConfig";
import CompanySelect from "@/components/globals/company-select.vue";

const formReady = ref(false);
const companies = ref([]);
const authStore = useAuthStore();
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
});
const formData = reactive({
    valid: false,
    type: null,
    company_id: null,
    serial_number: null,
    eth_mac: null,
    wifi_mac: null,
    cellular_imei: null,
    cellular_sim1_iccid: null,
    cellular_sim2_iccid2: null,
    ble_mac1: null,
    ble_mac2: null,
    ble_mac3: null,
    location_label: null,
    address_1: null,
    address_2: null,
    city: null,
    state: null,
    country_code: null,
    zip_postal_code: null,
    polygon_coordinates: null,
});
const emits = defineEmits(['update:modelValue', 'addUser']);
const dialogSwitch = ref(props.modelValue);
const errors = ref([]);
const mapContainer = ref();
const gatewayTypes = [
    {value: 1, title: "LORA"},
    {value: 2, title: "BLE to WIFI"},
    {value: 3, title: "BLE to Cellular"},
    {value: 4, title: "WIFI to Cellular"},
];

onMounted(() => {
    Promise.all([fetchCompaniesList()]).finally(() => formReady.value = true);
})
const fetchCompaniesList = () => {
    if (authStore.user.type !== 'admin') {
        formData.company_id = authStore.user.company.id;
    }
    return send('get', `companies/list`)
        .then((response) => {
            companies.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            snackbar.showSnackbar('Companies List could not be loaded', 'error')
        })
}

function mapIsReady() {
    const map = mapContainer.value.leafletObject;
    map.attributionControl.remove();
    const geoSearchOptions = new GeoSearchControl({
        style: "bar",
        autoClose: true,
        keepResult: true,
        showMarker: false,
        searchLabel: "Enter address",
        provider: new OpenStreetMapProvider({searchUrl: mapTiles.searchUrl, reverseUrl: mapTiles.reverseUrl}),
    });

    map.addControl(geoSearchOptions);
    /*Add Draw Tool Bar Control*/
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);
    const drawControl = new L.Control.Draw({
        draw: {
            circle: false,
            polygon: {
                showArea: true,
                allowIntersection: false, // Restricts shapes to simple polygons
                drawError: {
                    color: '#9d1212', // Color the shape will turn when intersects
                    message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                }
            },
            // disable toolbar item by setting it to false
            marker: false,
            polyline: false,
            rectangle: false,
            circlemarker: false,
        },
        edit: {
            featureGroup: drawnItems
        }
    });
    map.addControl(drawControl);

    map.on('draw:created', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });

        if (e.layerType === 'polygon') {
            formData['polygon_coordinates'] = e.layer.getLatLngs()[0];
        }
        drawnItems.addLayer(e.layer);
    });

    map.on('draw:edited', function (e) {
        e.layers.eachLayer(function (layer) {
            if (layer instanceof L.Polygon) {
                formData['polygon_coordinates'] = layer.getLatLngs()[0];
            }
        });
    });

    map.on('draw:deleted', function (e) {
        drawnItems.eachLayer(function (layer) {
            drawnItems.removeLayer(layer);
        });
        formData['polygon_coordinates'] = null;
    });
}

const storeGateway = () => {
    errors.value = [];
    send('post', `gateways`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('addGateway', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
